/** Rounds down to nearest 10 for marketing copy, e.g. 134 → "130+" */
export const formatMarketingCount = (count: number): string => {
    if (!count || count <= 0) return '0';
    if (count < 10) return `${count}+`;
    return `${Math.floor(count / 10) * 10}+`;
};
